import React from "react";
import { Link, useLocation } from "react-router-dom";

const DashboardLayout = ({ children }) => {
    const location = useLocation();

    const navItems = [
        { label: "Dashboard", path: "/" },
        { label: "Services", path: "/services" },
        { label: "Providers", path: "/providers" },
        { label: "Payouts", path: "/payouts" },
        { label: "Users", path: "/users" },
        { label: "Bookings", path: "/bookings" },
        { label: "Daily Booking Updates", path: "/daily-booking-updates" },
        { label: "Grocery Categories", path: "/grocery-categories" },
        { label: "Grocery Products", path: "/grocery-products" },
        { label: "Real Work Images", path: "/real-work-images" },
        { label: "Home Offers", path: "/home-offers" },
        { label: "User Offers", path: "/user-offers" },
        { label: "Car Cleaning Offer Spin", path: "/offers/08lm4nsW2ratEeO4BHSr" },
    ];

    return (
        <div className="flex h-screen bg-gray-50 text-gray-800">
            {/* Sidebar */}
            <aside className="w-64 shrink-0 overflow-y-auto bg-gradient-to-b from-blue-800 to-blue-600 text-white flex flex-col p-6 shadow-md">
                <div className="mb-10 flex flex-col items-center gap-3 text-center">
                    <img src="/app-logo.png" alt="Local Helper" className="h-16 w-16 rounded-2xl bg-white p-2 shadow-lg object-contain" />
                    <div>
                        <h2 className="text-2xl font-bold">Local Helper</h2>
                        <p className="text-sm text-blue-100">Admin Panel</p>
                    </div>
                </div>
                <nav className="flex flex-col gap-4">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`px-4 py-2 rounded-md transition-all duration-200 ${location.pathname === item.path
                                ? "bg-white text-blue-800 font-semibold"
                                : "hover:bg-blue-700 hover:pl-6"
                                }`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>
            </aside>

            {/* Main Content */}
            {/* my-auto (not items-center) centres short pages without pushing the
                top of tall pages out of the scrollable area. */}
            <main className="flex-1 flex justify-center p-6 overflow-auto">
                <div className="w-full max-w-6xl my-auto bg-white p-8 rounded-xl shadow-md">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default DashboardLayout;
